import type { FunctionComponent } from "react";
import { JsonLd } from "react-schemaorg";
import type { NewsArticle, OpinionNewsArticle } from "schema-dts";

import { useArticleSchemaContext } from "scmp-app/components/article/article-schema/contexts";
import type { SwGCompatibleSchema } from "scmp-app/components/article/article-schema/types";

type Props = Record<string, never>;

export const OpinionNewsArticleSchema: FunctionComponent<Props> = () => {
  const { schemaData } = useArticleSchemaContext();

  return schemaData ? (
    <JsonLd<SwGCompatibleSchema<NewsArticle, OpinionNewsArticle>>
      item={{
        "@context": "https://schema.org",
        "@type": ["NewsArticle", "OpinionNewsArticle"],
        ...schemaData,
      }}
    />
  ) : null;
};

OpinionNewsArticleSchema.displayName = "OpinionNewsArticleSchema";
